import React from 'react'
import { PageHeader } from '@reapit/elements'

type MaintenanceBlockProps = {
  outageMessage?: string
}

const MaintenanceBlock: React.FC<MaintenanceBlockProps> = ({ outageMessage }) => {
  return (
    <PageHeader
      style={{maxWidth: '100%'}}
      avatar={{
        src: 'error.png',
        type: 'image',
      }}
      hasMaxWidth
      pageTitle={{
        children: 'Looks like there is an issue...',
        hasBoldText: true,
      }}
      pageSubtitle={{
        children:
          outageMessage ? outageMessage : 'Our team is currently conducting essential maintenance. Please check back later for updates. Thank you for your understanding.',
      }}
    />
  )
}

export default MaintenanceBlock
